import { Box, Tab, Tabs, useTheme } from "@mui/material";
import PastToursList from "./pastToursList";
import BannerLayout from "../../layouts/bannerLayout";
import { useCallback, useEffect, useState } from "react";
import PastSitesAndActivitiesList from "./pastSitesAndActivitiesList";
import { useNavigate, useSearchParams } from "react-router-dom";

const navOptionList = [
    {label: "Saved Tours", value: 0},
    {label: "Saved Sites/Activities", value: 1}
]

const titleList = [
    {title: "Saved Tour Rates!", description: "Access and manage your library of previously calculated tour quotes."},
    {title: "Saved Sites & Activity Rates!", description: "View your full list of site entrance fees and activity costs."}
]

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

const PastToursLayout = ({navOption}) => {
    const theme = useTheme();

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const queryType = searchParams.get('type');

    const [value, setValue] = useState(0);

    useEffect(() => {
        if(queryType === 'tours'){
            setValue(0);
        }
        else if(queryType === 'sites_activities'){
            setValue(1);
        }
        else{
            navigate('/records?type=tours');
        }
    }, [queryType]);
    
    const changeTabOption = useCallback((event, newValue) => {
        if(newValue === 0){
            navigate('/records?type=tours');
        }
        else{
            navigate('/records?type=sites_activities');
        }
    }, []);

    return (
        <>
            <BannerLayout 
                navOptionIndex={navOption}
                title={titleList[value].title}
                description={titleList[value].description}
                children={
                    <>
                        {/* Ellipse */}
                        <Box
                            sx={{
                                mt: {xs: -10, sm: -20, md: -40},
                                display: {xs: 'flex', lg: 'none'}
                            }}
                        >
                            <img 
                                src="/images/Ellipse.png" 
                                alt="Ellipse" 
                                width='100%'
                            />
                        </Box>

                        <Box
                            sx={{
                                pt: {xs: 5, lg: 5},
                                px: {xs: 2, lg: 7},
                                mb: {xs: 2, lg: 0}
                            }}
                            width={{xs: 'fit-content', md: 'fit-content'}}
                        >
                            <Tabs
                                value={value}
                                onChange={changeTabOption}
                                sx={{
                                    backgroundColor: '#E5E5EA',
                                    borderRadius: '8px'
                                }}
                                slotProps={{
                                    indicator: {
                                        style: {
                                            display: 'none',
                                        }
                                    }
                                }}
                            >
                                {
                                    navOptionList.map((item, index) => {
                                        return <Tab 
                                            key={index}
                                            label={item.label}
                                            sx={{
                                                textTransform: 'none',
                                                fontWeight: 500,
                                                fontSize: '14px',
                                                color: 'black',
                                                letterSpacing: '0.36%',
                                                "&.Mui-selected": {
                                                    color: 'white',
                                                    backgroundColor: theme.palette.primary.light,
                                                    borderRadius: '8px',
                                                    fontWeight: 400,
                                                    m: {xs: 0, md: 0.5},
                                                    px: 1
                                                }
                                            }}
                                        />
                                    })
                                }
                            </Tabs>
                        </Box>

                        <CustomTabPanel value={value} index={0}>
                            <PastToursList />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={1}>
                            <PastSitesAndActivitiesList />
                        </CustomTabPanel>
                    </>
                }
            />
        </>
    );
}

export default PastToursLayout;